import React, { useEffect } from "react";
import { ReactSVG } from "react-svg";
import { formatNumber } from "src/utils/helper/functions";

const Assets: any = ({
  assetsData,
  showCashDetails,
  showAssetsDetails,
  setSelectedCashItem,
  setSelectedCashItemCurrency,
  selectedAccount,
}) => {
  const [data, setData] = React.useState<any[]>([]);

  useEffect(() => {
    setData(assetsData);
  }, [assetsData]);

  const getGroupByData = (data: any[]): any => {
    const groupedData = data.reduce((acc: any, obj: any) => {
      const key = obj.productGroupCode;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});

    if (groupedData?.CSH) {
      return {
        CSH: groupedData.CSH,
        ...groupedData,
      };
    } else {
      return groupedData;
    }
  };

  const getSumission = (data: any[]): number => {
    return data?.reduce(
      (accumulator, currentValue) =>
        accumulator + currentValue.reportingMarketAmount,
      0
    );
  };

  const onItemClicked = (item: any): void => {
    if (getGroupByData(data)[item][0]?.productGroupName === "Cash") {
      setSelectedCashItem(null);
      setSelectedCashItemCurrency(null);
      showCashDetails();
    } else {
      setSelectedCashItem(null);
      setSelectedCashItemCurrency(null);
      showAssetsDetails(getGroupByData(data)[item][0]?.productGroupCode);
    }
  };

  const scrollToDiv = (key: string) => {
    const element = document.getElementById(key);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return data?.length ? (
    <div className="mt-3 p-3 md:p-4 bg-white rounded-xl add-shadow flex-col justify-start items-center gap-3 inline-flex slide-right">
      <div className=" self-stretch  flex-col justify-start items-center gap-3 flex">
        <div className=" self-stretch  flex-col justify-start items-start gap-5 flex">
          <div className=" self-stretch justify-start items-center gap-4 inline-flex">
            <div className=" grow shrink basis-0 opacity-90 text-[#2a2a2a] text-sm md:text-base font-bold">
              Assets
            </div>
          </div>
          <div className=" self-stretch  flex-col justify-start items-start gap-3 flex">
            <div className=" self-stretch  flex-col justify-start items-start gap-3 flex">
              {Object.keys(getGroupByData(data)).map(
                (item: any, index: number) => (
                  <div
                    key={index}
                    className="cursor-pointer self-stretch px-3 py-4 md:p-4 bg-[#fdfdfd] rounded-xl add-shadow border border-[#ececec] justify-start items-center gap-4 inline-flex"
                    onClick={() => {
                      onItemClicked(item);
                      scrollToDiv(
                        getGroupByData(data)[
                          item
                        ][0]?.productGroupCode?.toLowerCase()
                      );
                    }}
                  >
                    <div className=" grow shrink basis-0 flex-col justify-center items-start gap-4 inline-flex">
                      <div className=" self-stretch justify-between items-center inline-flex">
                        <div className=" justify-start items-center gap-2 flex">
                          <div className=" w-[30px] h-[30px] relative">
                            <ReactSVG
                              src={
                                getGroupByData(data)[item][0]?.icon ||
                                "/images/cash-icon.svg"
                              }
                              className="svg-image"
                            />
                          </div>
                          <div className=" flex-col justify-start items-start gap-0.5 inline-flex">
                            <div className=" self-stretch justify-start items-center gap-1 inline-flex">
                              <div className=" text-[#2a2a2a] text-xs md:text-sm font-semibold leading-snug tracking-tight">
                                {
                                  getGroupByData(data)[item][0]
                                    ?.productGroupName
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="Frame576310 justify-end items-center gap-2 flex">
                          <div className="Label text-[#2a2a2a] text-sm md:text-base font-semibold leading-relaxed tracking-tight">
                            {getSumission(getGroupByData(data)[item]) >= 0
                              ? formatNumber(
                                  getSumission(getGroupByData(data)[item]),
                                  selectedAccount?.reportingCurrencyDcp
                                )
                              : `(${formatNumber(
                                  Math.abs(
                                    getSumission(getGroupByData(data)[item])
                                  ),
                                  selectedAccount?.reportingCurrencyDcp
                                )})`}
                          </div>
                          <div className="ArrowRight w-6 h-6 justify-center items-center flex">
                            <img
                              src="/images/arrow-right.svg"
                              width={24}
                              height={24}
                              alt="estate"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    ""
  );
};

export default Assets;
